import { useEffect, useState } from 'react';
import styled from '@emotion/styled';

import { screen } from '@/components/common/breakpoints';
import { SecondaryButton } from '@/components/common/Buttons';
import { RichHeading } from '@/components/common/Heading';
import { PortableText } from '@/components/common/utils';
import { getClient } from '@/lib/sanityUtils';

const Thankyou = ({
  thankYouMsgHeading,
  thankYouMsgBody,
  downloadFile,
  thankYouCTALabel,
  thankYouCTAHrefExternal,
  thankYouCTAHrefInternal,
}) => {
  const [buttonInternalURL, setButtonInternalURL] = useState(null);

  useEffect(() => {
    if (thankYouCTAHrefInternal) {
      const client = getClient();
      client
        .fetch(
          `*[_type=='page' && _id == '${thankYouCTAHrefInternal._ref}']{slug}`,
        )
        .then((response) => {
          setButtonInternalURL(response[0]?.slug?.current);
        });
    }
  });

  return (
    <Container>
      <ThankYouHeadingWrapper>
        <RichHeading heading={thankYouMsgHeading} size="heading-lg" />
      </ThankYouHeadingWrapper>
      <ThankYouBodyWrapper>
        <PortableText value={thankYouMsgBody} />
      </ThankYouBodyWrapper>
      {thankYouCTALabel &&
        thankYouCTAHrefExternal &&
        !downloadFile &&
        !buttonInternalURL && (
          <ButtonLink componentTheme="light" href={thankYouCTAHrefExternal}>
            {thankYouCTALabel}
          </ButtonLink>
        )}
      {thankYouCTALabel && buttonInternalURL && !downloadFile && (
        <ButtonLink href={`/${buttonInternalURL}`} componentTheme="light">
          {thankYouCTALabel}
        </ButtonLink>
      )}
      {thankYouCTALabel && downloadFile && (
        <ButtonLink href={downloadFile} componentTheme="light">
          {thankYouCTALabel}
        </ButtonLink>
      )}
    </Container>
  );
};

const ThankYouHeadingWrapper = styled.div`
  text-align: left;
  padding-bottom: var(--spacing-500);

  ${screen.md} {
    padding-bottom: var(--spacing-300);
  }
`;

const ThankYouBodyWrapper = styled.div`
  text-align: left;

  p {
    margin-bottom: 12px;
  }

  b {
    font-weight: bold;
  }

  ul,
  ol {
    list-style: inside;
    margin-bottom: 12px;

    em {
      font-style: italic;
    }
  }

  ol {
    list-style-type: decimal;
  }

  a {
    text-decoration: underline;
    color: inherit;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: inherit;
  height: 100%;
  width: 100%;
  color: var(--text-strong);
  justify-content: center;
  align-items: flex-start;
  padding: 0 var(--spacing-300);

  ${screen.md} {
    padding: 0 var(--spacing-500);
  }

  a {
    margin-top: var(--spacing-500);
  }
`;

const ButtonLink = styled(SecondaryButton)`
  line-height: normal;
`;

export { Thankyou };
